import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-news',
  templateUrl: './master-news.component.html',
  styleUrls: ['./master-news.component.scss']
})
export class MasterNewsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/master-news/master-news.component.ts